import {initPurchaseConfirmationResult} from '@web/actions/purchaseConfirmation'
import makeSlice from '@web/slices/purchaser/sliceMaker'

const purchaserSlice = makeSlice({
    extraReducers: (builder) => {
        builder.addCase(initPurchaseConfirmationResult.fulfilled, (state, {payload: {data}}) => {
            state.naverMembership.subscribed = data.naverMembership?.subscribed ?? false
        })
    },
})

export default purchaserSlice.reducer
